import { platformIntl } from '../../../constants';
import { CorpGroupConfig, RangeType } from '../../../interfaces';

const getDeptRangeText = (type: RangeType) => {
    if (type === RangeType.All) {
        return platformIntl.get('fxp.base.bg.admin.all_dept.opt');
    } else {
        return platformIntl.get('fxp.base.bg.admin.part_dept.opt');
    }
};

export const getDeptAuthTextValue = (config: CorpGroupConfig) => {
    const { op, dept_range_type } = config;
    const texts = [];

    if (op.memberRead && op.memberWrite) {
        texts.push(platformIntl.get('fxp.base.bg.admin.view_mgmt.opt'));
        texts.push(getDeptRangeText(dept_range_type));
    } else if (op.memberRead && !op.memberWrite) {
        texts.push(platformIntl.get('fxp.base.bg.admin.view_no_mgmt.opt'));
        texts.push(getDeptRangeText(dept_range_type));
    } else if (!op.memberRead && !op.memberWrite) {
        texts.push(platformIntl.get('fxp.base.bg.admin.no_view_mgmt.opt'));
    }

    return texts.join('-');
};

const getRoleRangeText = (type: RangeType) => {
    if (type === RangeType.All) {
        return platformIntl.get('fxp.base.bg.admin.all_role.opt');
    } else {
        return platformIntl.get('fxp.base.bg.admin.part_role.opt');
    }
};

export const getRoleAuthTextValue = (config: CorpGroupConfig) => {
    const { op, role_range_type } = config;
    const texts = [];

    if (op.roleRead && op.roleWrite) {
        texts.push(platformIntl.get('fxp.base.bg.admin.view_mgmt.opt'));
        texts.push(getRoleRangeText(role_range_type));
    } else if (op.roleRead && !op.roleWrite) {
        texts.push(platformIntl.get('fxp.base.bg.admin.view_no_mgmt.opt'));
        texts.push(getRoleRangeText(role_range_type));
    } else if (!op.roleRead && !op.roleWrite) {
        texts.push(platformIntl.get('fxp.base.bg.admin.no_view_mgmt.opt'));
    }

    return texts.join('-');
};

export const getCoopAuthTextValue = (config: CorpGroupConfig) => {
    const { op } = config;

    if (op.corpCoopManage) {
        return platformIntl.get('fxp.base.bg.admin.view_mgmt.opt');
    } else {
        return platformIntl.get('fxp.base.bg.admin.no_view_mgmt.opt');
    }
};

/** 获取外部权限摘要 */
export const getExternalAuthTextValue = (enabled: boolean) => {
    if (enabled) {
        return platformIntl.get('fxp.base.bg.admin.view_mgmt.opt');
    }

    return platformIntl.get('fxp.base.bg.admin.no_view_mgmt.opt');
};
